import { QueryParamsModel } from '../../../_base/crud/models/query-models/query-params.model';
import { forkJoin } from 'rxjs';
// Angular
import { Injectable } from '@angular/core';
// RxJS
import { mergeMap, map, tap, delay } from 'rxjs/operators';
// NGRX
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../../_base/crud';
// Services
import { MinesMasterService } from '../_services/minesMaster.service';
import { ShareddataserviceService } from '../../../../shared/shareddataservice.service';
// State
import { AppState } from '../../../../core/reducers';
// Actions
import {
    MinesMasterActionTypes,
    MinesMasterPageRequested,
    MinesMasterPageLoaded,
    OneMinesMasterDeleted,
    MinesMasterActionToggleLoading,
    MinesMasterPageToggleLoading,
    MinesMasterUpdated,
    MinesMasterCreated,
    MinesMasterOnServerCreated
} from '../_actions/minesMaster.actions';
import { of } from 'rxjs';

@Injectable()
export class MinesMasterEffects {
    showPageLoadingDistpatcher = new MinesMasterPageToggleLoading({ isLoading: true });
    showActionLoadingDistpatcher = new MinesMasterActionToggleLoading({ isLoading: true });
    hideActionLoadingDistpatcher = new MinesMasterActionToggleLoading({ isLoading: false });

    @Effect()
    loadMinesMasterPage$ = this.actions$.pipe(
        ofType<MinesMasterPageRequested>(MinesMasterActionTypes.MinesMasterPageRequested),
        mergeMap(({ payload }) => {
            this.store.dispatch(this.showPageLoadingDistpatcher);
            const requestToServer = this.minesMasterService.findMinesMasters(payload.page);
            const lastQuery = of(payload.page);
            return forkJoin(requestToServer, lastQuery);
        }),
        map(response => {
            const result: QueryResultsModel = response[0];
            const lastQuery: QueryParamsModel = response[1];

            this.sharedService.updatemineList(result.items);
            //console.log(result.items);
            const pageLoadedDispatch = new MinesMasterPageLoaded({
                minesMasters: result.items,
                totalCount: result.totalCount,
                page: lastQuery
            });
            return pageLoadedDispatch;
        })
    );

    @Effect()
    deleteMinesMaster$ = this.actions$
        .pipe(
            ofType<OneMinesMasterDeleted>(MinesMasterActionTypes.OneMinesMasterDeleted),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.minesMasterService.deleteMinesMaster(payload.MinesMId);
            }
            ),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            }),
        );

    @Effect()
    updateMinesMaster$ = this.actions$
        .pipe(
            ofType<MinesMasterUpdated>(MinesMasterActionTypes.MinesMasterUpdated),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.minesMasterService.updateMinesMaster(payload.minesMaster.MinesMId, payload.minesMaster);
            }),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            })
        );

    @Effect()
    createMinesMaster$ = this.actions$
        .pipe(
            ofType<MinesMasterOnServerCreated>(MinesMasterActionTypes.MinesMasterOnServerCreated),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.minesMasterService.createMinesMaster(payload.minesMaster).pipe(
                    tap(res => {
                        //console.log(res);
                        //const resValue = Object.keys(res).map(key => res[key]);
                        //console.log(resValue[0].value);
                        //this.store.dispatch(new MinesMasterCreated({ minesMaster: res }));
                        if (res.MinesMId == 0) {
                            this.store.dispatch(new MinesMasterCreated({ minesMaster: res }));
                        } else {
                            console.log('There is somthing wrong');
                            //this.store.dispatch(new MinesMasterErrorMessage({ _errorMessage: resValue[0].value }));
                        }

                    })
                );
            }),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            }),
        );

    constructor(private actions$: Actions, private minesMasterService: MinesMasterService,
        private sharedService: ShareddataserviceService, private store: Store<AppState>) { }
}
